/* Black Friday 2026 (návrh B „Cenovka“, schválil majitel 4. 11. 2026).
   Načítá se z layout/theme.liquid jen během okna BLACKFRIDAY (snippets/kl-akce.liquid),
   v hlavičce s defer, takže běží PŘED hp-page.js (ten je v těle stránky).
   - kalendář: nejdřív přepne prvky s data-kl-kalendar (BF ↔ normální HP), aby další kroky
     viděly skutečný stav i na stránce vydané z cache Shopify.
   - kotva #modely: během akce ji nese nabídka Black Friday. Když je nabídka po konci akce
     skrytá, vrátí se kotva normálnímu rozcestníku – hp-page.js podle ní ukazuje lepicí lištu.
   - odpočet: [data-bf-odpocet] s data-bf-do (epocha konce z Liquidu) a potomky
     [data-d] [data-h] [data-m] [data-s]; popisek dnů [data-bf-dny] se skloňuje podle
     data-d1 / data-d2 / data-d5 (1 / 2–4 / ostatní).
   - kód: [data-bf-kod] zkopíruje kód, na 2 s dostane .is-copied a text [data-bf-kod-stav]
     se přepne na data-hotovo.
   - nájezdy: [data-bf-reveal] dostanou .is-in; bez skriptu jsou vidět hned (fail-open). */
(function () {
  var de = document.documentElement;
  de.classList.add('bf-js');
  if (window.klAkcePrepni) window.klAkcePrepni();

  var bf = document.querySelector('.bfb-offer'), std = document.querySelector('[data-bf-std="modely"]');
  if (bf && std) {
    if (bf.classList.contains('kl-mimo')) { bf.id = 'modely-bf'; std.id = 'modely'; }
    else { std.id = 'modely-std'; bf.id = 'modely'; }
  }

  var dva = function (n) { return (n < 10 ? '0' : '') + n; };
  function tik() {
    var nyni = Date.now() / 1000;
    document.querySelectorAll('[data-bf-odpocet]').forEach(function (el) {
      var zbyva = Math.max(0, Math.floor(+el.getAttribute('data-bf-do') - nyni));
      var d = Math.floor(zbyva / 86400), h = Math.floor(zbyva % 86400 / 3600),
          m = Math.floor(zbyva % 3600 / 60), s = zbyva % 60;
      var p = { d: dva(d), h: dva(h), m: dva(m), s: dva(s) };
      Object.keys(p).forEach(function (k) {
        el.querySelectorAll('[data-' + k + ']').forEach(function (x) {
          if (x.textContent !== p[k]) {
            x.textContent = p[k];
            x.classList.remove('is-tik'); void x.offsetWidth; x.classList.add('is-tik');
          }
        });
      });
      el.querySelectorAll('[data-bf-dny]').forEach(function (x) {
        var t = d === 1 ? x.getAttribute('data-d1') : (d >= 2 && d <= 4 ? x.getAttribute('data-d2') : x.getAttribute('data-d5'));
        if (t && x.textContent !== t) x.textContent = t;
      });
    });
  }
  tik(); setInterval(tik, 1000);

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-bf-kod]');
    if (!b) return;
    e.preventDefault();
    var kod = b.getAttribute('data-bf-kod');
    var st = b.querySelector('[data-bf-kod-stav]');
    var hotovo = function () {
      b.classList.add('is-copied');
      if (st) { st.dataset.puvodni = st.dataset.puvodni || st.textContent; st.textContent = st.getAttribute('data-hotovo') || kod; }
      clearTimeout(b._t);
      b._t = setTimeout(function () { b.classList.remove('is-copied'); if (st) st.textContent = st.dataset.puvodni; }, 2000);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(kod).then(hotovo, hotovo);
    else hotovo();
  });

  var cile = document.querySelectorAll('[data-bf-reveal]');
  var bezPohybu = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (bezPohybu || !('IntersectionObserver' in window)) {
    cile.forEach(function (el) { el.classList.add('is-in'); });
  } else {
    var io = new IntersectionObserver(function (z) {
      z.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    cile.forEach(function (el) { io.observe(el); });
  }
})();
